let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("27j4b")).then(() => parcelRequire('eD2bY'));